import * as BABYLON from "@babylonjs/core";
import { VirtualDisplay } from "../display";
import { InputsNavigationController } from "core/map";
import { Map3D } from "./map";
export class MapNode extends BABYLON.TransformNode {
    constructor(name, scene) {
        super(name, scene);
        this._pointerController = null;
        this._ownPointerController = false;
        this._map = this._createMap();
        this._beforeRenderObserver = this.getScene().onBeforeRenderObservable.add(this._onBeforeRender.bind(this));
    }
    get layers() {
        return this._map.layers;
    }
    get navigationState() {
        return this._map.navigationState;
    }
    setViewMap(center, zoom, rotation, validate) {
        this._map.setViewMap(center, zoom, rotation, validate);
        return this;
    }
    zoomMap(delta, validate) {
        this._map.zoomMap(delta, validate);
        return this;
    }
    zoomInMap(delta, validate) {
        this._map.zoomInMap(delta, validate);
        return this;
    }
    zoomOutMap(delta, validate) {
        this._map.zoomOutMap(delta, validate);
        return this;
    }
    translateUnitsMap(tx, ty, validate) {
        this._map.translateUnitsMap(tx, ty, validate);
        return this;
    }
    translateMap(dlat, dlon, validate) {
        this._map.translateMap(dlat, dlon, validate);
        return this;
    }
    rotateMap(r, validate) {
        this._map.rotateMap(r, validate);
        return this;
    }
    get map() {
        return this._map;
    }
    withDisplay(display) {
        this._map.display = display;
        if (display instanceof VirtualDisplay) {
            this.parent = display.context3D;
            return this._withPointerControl(display.pointerSource);
        }
        else if (display instanceof BABYLON.Node) {
            this.parent = display;
        }
        return this;
    }
    withElevationExageration(e) {
        this.map.elevationOptions.exageration = e;
    }
    _withPointerControl(controller) {
        if (this._pointerController === controller)
            return this;
        if (this._pointerController && this._ownPointerController) {
            this._pointerController.dispose();
        }
        if (controller instanceof InputsNavigationController) {
            this._pointerController = controller;
        }
        else {
            this._pointerController = new InputsNavigationController(controller, this._map);
            this._ownPointerController = true;
        }
        return this;
    }
    _createMap() {
        return new Map3D(this);
    }
    _onBeforeRender(eventData, eventState) {
        this._map.validate();
    }
    dispose(doNotRecurse, disposeMaterialAndTextures) {
        this._pointerController?.dispose();
        this._beforeRenderObserver?.remove();
        this._map.dispose();
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
}
//# sourceMappingURL=map.node.js.map